/**
 * @fileoverview POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/sending_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeSendingDomainsCacheKeys } from "./constants";
import type { PostCompaniesCompanyIdEmailSelfServeSendingDomainsProps, PostSendingDomainResult } from "./types";

export const postSendingDomain = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeSendingDomainsCacheKeys,
  (props: PostCompaniesCompanyIdEmailSelfServeSendingDomainsProps): Promise<PostSendingDomainResult> => {
    const { companyId, appGroupId, ...requestBody } = props;
    return fetch(
      `/companies/${companyId}/email_self_serve/${appGroupId}/sending_domains`,
      "POST",
      requestBody,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
